module.exports = __webpack_public_path__ + "img/head-side-headphones.bc8b7ee2.svg";